import React from "react";
import RoleGuard from "@/components/RoleGuard";

/**
 * @deprecated Use `<RoleGuard mode="user">` diretamente.
 * Mantido como wrapper fino para compatibilidade com rotas e testes existentes.
 */
const ProtectedRoute = React.forwardRef<HTMLDivElement, { children: React.ReactNode }>(
  ({ children }, _ref) => <RoleGuard mode="user">{children}</RoleGuard>
);

ProtectedRoute.displayName = "ProtectedRoute";

export default ProtectedRoute;
